<template>
  <div class="content">
    <div class="head-box" :style="{ paddingTop: statusBarHeight }">
      <img
        class="head-bg"
        src="@/assets/images/h5-bg.jpg"
        alt=""
      />
	  <div class="head">
	    <!-- <i class="iconfont icon-xiangzuo" @click="onBack"></i> -->
	    <span>分享海报</span>
	  </div>
    </div>
	
    <img
      class="_w-max"
      src="@/assets/images/h5-bg.jpg"
      alt=""
    />
	
	<div class="tips-box"  v-if="info.length>0">
		<img
			class="_w-max"
			:src="info[0].wap_poster"
			alt=""
		/>
	</div>
	<div class="tips-box"  v-else>
		<div style="height: 300px; text-align: center;margin-top: 150px;">海报生成中</div>
	</div>
	<div style="text-align: center;margin-top: 10px;">--请长按图片保存--</div>
	<!-- <div style="width: 100%;padding: 0 0.56rem; margin-top: 20px;" @click="saveImg"> <img
      class="_w-max"
      src="https://sz.daolongsz.com/static/h5-bc.jpg"
      alt=""
    /></div> -->
	<div style="height: 1.2rem;"></div>
  </div>
</template>

<script>
	import { getSpreadImg } from "../../../api/user";
import { getUserInfo } from "@api/user";
import { isWeixin } from "@utils/index";
import { getUser } from "@api/user";
import { Toast } from "vant";
import { mapGetters } from "vuex";
export default {
	data: function () {
		return {
			isWeixin: isWeixin(),
			qrcode:'',
			info:[],
		};
	},
	computed: mapGetters(["isLogin"]),
	created() {
		this.$router.push('/');
	},
	mounted: function () {
		let that = this;
		if (that.isLogin) {
			that.getIndex();
			getUserInfo().then(res => {
				that.userInfo = res.data;
				that.qrcode = res.data.qrcode;
				console.log(res.data);
			});
		}
	},
	methods: {
		getIndex: function() {
		  let that = this;
		  getSpreadImg().then(
		    res => {
		      that.info = res.data;
		    },
		    err => {
		      that.$dialog.message(err.msg);
		    }
		  );
		},
		downloadIamge: function(imgsrc, name) {
		  let image = new Image();
		  image.setAttribute("crossOrigin", "anonymous");
		  image.onload = function() {
		    let canvas = document.createElement("canvas");
		    canvas.width = image.width;
		    canvas.height = image.height;
		    let context = canvas.getContext("2d");
		    context.drawImage(image, 0, 0, image.width, image.height);
		    let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
		    let a = document.createElement("a"); // 生成一个a元素
		    let event = new MouseEvent("click"); // 创建一个单击事件
		    a.download = name || "photo"; // 设置图片名称
		    a.href = url; // 将生成的URL设置为a.href属性
		    a.dispatchEvent(event); // 触发a的单击事件
		  };
		  image.src = imgsrc;
		},
		saveImg: function() {
		  console.log('https://sz.daolongsz.com/static/h5-hb.jpg');
		  this.downloadIamge(
		    'https://sz.daolongsz.com/static/h5-hb.jpg',
		    "poster"
		  );
		}
	},
};
</script>

<style lang="scss" scoped>
	.erweima{
		position: absolute;
		bottom: 45px;
		left: 110px;
	}
.content {
  min-height: 100vh;
  background: #fff9ef;
}
.head-box {
  width: 100%;
  overflow: hidden;
  position: relative;
  position: fixed;
  top: 0;
  z-index: 999;
  .head-bg {
    position: absolute;
    top: 0;
    width: 100%;
  }
  .head {
    position: relative;
    width: 100%;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    font-size: 0.32rem;
    color: #fff;
    .iconfont {
      position: absolute;
      top: 50%;
      left: 0.3rem;
      transform: translateY(-50%);
      font-size: 0.4rem;
    }
  }
}
.tips-box {
  width: 100%;
  padding: 0 0.56rem;
  margin-top: -1.98rem;
  position: relative;
}
.write-tips {
  height: 0.54rem;
}
.form-bg {
  width: 100%;
  .form-box {
    width: calc(100% - 0.56rem);
    margin: 0.38rem auto 0;
    position: relative;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(https://sz.daolongsz.com//static/test-bg.png);
    .sex-box {
      width: 100%;
      padding: 0.6rem 0.22rem 0.4rem 0.32rem;
      border-bottom: 0.02rem solid rgba(105, 80, 60, 0.1);
      font-size: 0.28rem;
      color: #69503c;
    }
    .birthday-box {
      width: 100%;
      padding: 0.4rem 0 0.8rem 0;
      font-size: 0.28rem;
      color: #69503c;
      .padding-x {
        padding-left: 0.32rem;
        padding-right: 0.32rem;
      }
      .day-box {
        min-width: 1.36rem;
        padding: 0.2rem;
        border-radius: 0.05rem;
        background-color: rgba(255, 251, 245, 1);
      }
      .year-box {
        min-width: 1.56rem !important;
      }
      .time-box {
        min-width: 2.46rem !important;
      }
      .input-box {
        width: 100%;
        padding: 0.34rem 0.32rem;
        border-bottom: 1px solid rgba(105, 80, 60, 0.1);
        color: #69503c;
        font-size: 0.28rem;
      }
      .report-box {
        width: 1.66rem;
        height: 0.82rem;
      }
      .read-box {
        width: 4.22rem;
        height: 0.82rem;
      }
    }
  }
}
.bottom-pic {
  width: 2.48rem;
  height: 2.26rem;
}

.bottom-mid-pic {
  width: 2.38rem;
  height: 0.6rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.bottom-pics {
  width: 2.8rem;
  height: 1.82rem;
}
.picler-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: 0.3);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>